// Single source of truth for call-reason German labels and badge/pie colors.
// Consumed by DashboardPage (Anrufgründe pie chart) and TasksPage (Grund column badges).
//
// Brand palette (mirrors CSS custom properties in App.css):
//   --color-main:       #1b3f65  (dark blue)
//   --color-secondary:  #2F6BD7  (bright blue)
//   --color-tertiary:   #fa8862  (coral)
//   --color-quaternary: #7bd389  (green)
//
// We have 6 reasons but only 4 brand colors. The two leftover reasons
// (callback, other) use neutral grey shades so they don't clash with the
// brand-colored slices.

export const CALL_REASON_CONFIG = {
  booking: {
    label: 'Terminbuchung',
    bg: '#1b3f65',  // --color-main
    fg: '#ffffff',
  },
  cancelling: {
    label: 'Stornierung',
    bg: '#fa8862',  // --color-tertiary
    fg: '#ffffff',
  },
  moving: {
    label: 'Terminänderung',
    bg: '#7bd389',  // --color-quaternary
    fg: '#ffffff',
  },
  info: {
    label: 'Information',
    bg: '#2F6BD7',  // --color-secondary
    fg: '#ffffff',
  },
  callback: {
    label: 'Rückruf',
    bg: '#6c757d',  // neutral grey (matches --text-secondary)
    fg: '#ffffff',
  },
  other: {
    label: 'Sonstiges',
    bg: '#adb5bd',  // lighter neutral grey
    fg: '#1b3f65',  // dark text on light grey for contrast
  },
};

const FALLBACK = { label: '', bg: '#9ca3af', fg: '#ffffff' };

// Resolve a config entry by either reason key (e.g. "booking") or German
// label (e.g. "Terminbuchung"). Returns a safe fallback if unknown.
export const getCallReasonConfig = (reasonOrLabel) => {
  if (!reasonOrLabel) return FALLBACK;
  if (CALL_REASON_CONFIG[reasonOrLabel]) return CALL_REASON_CONFIG[reasonOrLabel];
  const byLabel = Object.values(CALL_REASON_CONFIG).find(c => c.label === reasonOrLabel);
  return byLabel || { ...FALLBACK, label: reasonOrLabel };
};

export const getCallReasonLabel = (reasonKey) =>
  CALL_REASON_CONFIG[reasonKey]?.label || reasonKey;
